import  "./NotificationCard.css"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import {linkificar} from '../../scripts/linkificar.js'

export default function NotificationRow({ notification }) {

    const navigate = useNavigate()
    const [expanded, setExpanded] = useState(false)

    const truncate = (text, limit) => {
        if (text.length <= limit) return text
        return text.slice(0, limit) + "..."
    
    }

    const handleClick = () => {
        console.log(notification)
        navigate(`/notifications/${notification.notification.id}/${notification.sendNotifications ? 1 : 0}`)
    }

    return ( 
        <div>
        {
            notification.sendNotifications ? (
                <div onClick={() => setExpanded(!expanded)}  className={`row`}>
                    <div className="left">
                        <span className="sender" style={{width: "200px"}}>Tu: {notification.transmitter.name_user} para {notification.receiver.name_user}</span>
                        <span className="title">{notification.notification.title}</span>
                        <span className="body">{truncate(notification.notification.body, 50)}</span>
                    </div>
                    <div className="right">
                        <span className="date">{new Date(notification.notification.created_at).toLocaleString('es-ES')}</span>
                        <span className={`status ${!notification.notification.is_read ? "status--unread" : "status--read"}`}>
                            {notification.notification.is_read ? "Leído" : "No leído"}
                        </span>
                    </div>
                    {expanded && (
                        <div className="expanded-content" onClick={e => e.stopPropagation()}>
                            <p className="expanded-body">{ linkificar(notification.notification.body)}</p>
                            <span className="expanded-meta">
                                Enviado a: {notification.transmitter.name_user}
                            </span>
                        </div>
                     )}
                </div>
            ) : (
                <div onClick={handleClick} className={`row ${!notification.notification.is_read ? "unread" : ""}`}>
                    <div className="left">
                        <span className="sender" style={{width: "150px"}}>{notification.transmitter.name_user}</span>
                        <span className="title">{notification.notification.title}</span>
                        <span className="body">{truncate(notification.notification.body, 50)}</span>
                    </div>
                    <span className="date">{new Date(notification.notification.created_at).toLocaleString('es-ES')}</span>          
                </div>
            )
        }
        </div>
    )
}